import availableFonts from "./availableFonts";

const loadFonts = async () => {
    availableFonts.forEach(font => {
        //skip if no url
        if (!font.url) return;
        const link = document.createElement("link");
        link.href = font.url;
        link.rel = "stylesheet";
        document.head.appendChild(link);
    });
};

export default loadFonts;
